import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'

import DeleteTrip from '../Trips/DeleteTrip'

import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import type { BasicTrip, FullTrip } from 'tripPlanner/types/common'
import { getTripPermissions } from 'tripPlanner/utils'

interface Props {
  trip: BasicTrip | FullTrip
}

export default function TripPanelActionMenu(props: Props) {
  const intl = useIntl()
  const { trip } = props
  const [mode, setMode] = useState<'view' | 'delete'>('view')
  const onDeleteTripClicked = useCallback(() => setMode('delete'), [])
  const { canAdmin } = getTripPermissions(trip)

  return (
    <ModalBase dismissible={mode !== 'delete'}>
      {mode === 'view' && (
        <>
          <ModalHeader title={trip.name} />
          <ModalBody>
            <ModalContent>
              {canAdmin && (
                <ClickableListItem
                  startIcon={<LineTrashAltIcon size="S" />}
                  onClick={onDeleteTripClicked}
                  title={intl.formatMessage({
                    id: 'Sn0SHhM2IaLGD-fuQzZY',
                    defaultMessage: 'Delete trip',
                    description: 'Action menu item to delete the trip in the trip planner feature',
                  })}
                />
              )}
            </ModalContent>
          </ModalBody>
        </>
      )}
      {mode === 'delete' && <DeleteTrip trip={trip} />}
    </ModalBase>
  )
}
